import { Caption, Flex, useStyles } from '@archipro-design/aria';
import * as S from './ImageCaption.style';
import parse from 'html-react-parser';
import { cn } from '@rocco/utils/cn';

interface ImageCaptionProps {
    text: string;
    isMain?: boolean;
    moduleType?: string;
    isProject?: boolean;
    inViewPort?: boolean;
    isPageBuilder?: boolean;
}

const ImageCaption = ({
    text,
    isMain,
    moduleType,
    isProject,
    inViewPort,
    isPageBuilder,
}: ImageCaptionProps) => {
    const { css } = useStyles({
        moduleType,
        isProject,
        inViewPort,
        isPageBuilder,
    });
    const captionStyle = isMain
        ? S.TagMainCaptionContainer
        : S.TagSubCaptionContainer;
    const captionAsReactElements = parse(text);

    return (
        <Flex className={cn(css(captionStyle), 'font-display! font-normal!')}>
            <Caption variant="03-alt">{captionAsReactElements}</Caption>
        </Flex>
    );
};

export default ImageCaption;
